export default "__VITE_ASSET__BU1kXkrg__"